import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=2370a032&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=ts&"
export * from "./Form.vue?vue&type=script&lang=ts&"
import style0 from "./Form.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Form.vue?vue&type=style&index=1&id=2370a032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370a032",
  null
  
)

export default component.exports